import React from 'react'
import '../style.scss'
import Header from './header'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Pagination from './pagination'

// markup
class Layout extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <>
        <Header location={this.props.path}></Header>
        <div>
          <CSSTransition
            in={
              this.props.path.split('/')[1] !== 'list' &&
              this.props.path.split('/')[1] !== 'about'
            }
            timeout={500}
            unmountOnExit
          >
            <Pagination location={this.props.path} />
          </CSSTransition>
        </div>
        <TransitionGroup className="view">
          <CSSTransition key={this.props.path} timeout={500}>
            {this.props.children}
          </CSSTransition>
        </TransitionGroup>
      </>
    )
  }
}

export default Layout
